import React, { Component } from "react";
import { Modal, DatePicker, message, Select } from "antd";
import axios from "services/axios";
import _ from "lodash";
import momentTZ from "moment-timezone";
import { getCarName, backFormatRupiah } from "../../../Utils";
import downloadExcel from "../../../../services/downloadExcel";

const { Option } = Select;

class ModalDownload extends Component {
  state = {
    isLoading: false,
    branches: [],
    branch: null,
    statusData: "",
    rawStatus: "All",
    startDate: null,
    endDate: null,
  };

  componentDidMount() {
    this.fetchBranch();
  }

  // ************************* Function Change Data *************************//
  onChangeRange(date, dateString) {
    let startDate = dateString[0]
      ? momentTZ(dateString[0]).format("YYYY-MM-DD")
      : null;
    let endDate = dateString[1]
      ? momentTZ(dateString[1]).format("YYYY-MM-DD")
      : null;
    this.setState({ rangeTime: dateString, startDate, endDate });
  }

  onChangeDate(date) {
    const data = momentTZ(date)
      .tz("Asia/Jakarta")
      .format("dddd, D MMMM YYYY HH:mm");
    return data;
  }

  onChangeDownload(date) {
    const data = momentTZ(date).tz("Asia/Jakarta").format("D MMM YYYY");
    return data;
  }

  onCancel() {
    this.setState({ rangeTime: [] });
    this.props.visibleModal(false);
  }

  // ************************* Function Download Data *************************//
  filterDataApproval(approval) {
    let branch = _.get(approval, "SalesProfile.SalesBranch.branch");
    let salesNames = _.get(approval, "SalesProfile.name");
    let approvalPIC = _.get(approval, "ApprovalCompletionBy.name");
    let spkPIC = _.get(approval, "SPKCompletionBy.name");
    let spkNotes = "";
    let statusSPK = "";
    if (["Done", "SPK Reject", "Approved"].includes(approval.status)) {
      if (approval.status === "Approved") {
        statusSPK = approval.spkNotes ? "Reject" : "";
        spkNotes = approval.spkNotes;
      } else {
        statusSPK = approval.status === "Done" ? "Approve" : "Reject";
        spkNotes = approval.status === "SPK Reject" ? approval.spkNotes : "";
      }
    }

    let calculationData = {};
    console.log(calculationData, "calculationData");
    approval.calculationDetail &&
      approval.calculationDetail.map((v) => {
        switch (v.name) {
          case "Kilometer":
            calculationData.km = v.value;
            break;
          case "Stock Days":
            calculationData.stockDays = v.value;
            break;
          case "OTR":
            calculationData.otr = v.priceTotal;
            break;
          case "DPP":
            calculationData.dpp = v.priceTotal;
            break;
          case "Unit Purchase":
            calculationData.unitPurchase = v.priceTotal;
            break;
          case "Unit Kinto PPN":
            calculationData.unitKintoPPN = v.isStatus ? v.priceTotal : 0;
            break;
          case "Mobilisasi Unit":
            calculationData.mobilisasiUnit = v.priceTotal;
            break;
          case "Sales Commission":
            calculationData.salesCommision = v.priceTotal;
            break;
          case "Sourching Fee":
            calculationData.sourchingFee = v.isStatus ? v.priceTotal : 0;
            break;
          case "Selling Fee":
            calculationData.sellingFee = v.isStatus ? v.priceTotal : 0;
            break;
          case "Lelang":
            calculationData.lelang = v.priceTotal;
            break;
          case "General Repair":
            calculationData.generalRepair = v.priceTotal;
            break;
          case "Body Repair":
            calculationData.bodyRepair = v.priceTotal;
            break;
          case "Biaya Pajak STNK":
            calculationData.biayaPajakSTNK = v.priceTotal;
            break;
          case "BBM Stock Unit":
            calculationData.bbmStockUnit = v.priceTotal;
            break;
          case "Others":
            calculationData.others = v.priceTotal;
            break;
          case "Total Cost":
            calculationData.totalCost = v.priceTotal;
            break;
          case "Available Margin":
            calculationData.availableMargin = v.priceTotal;
            break;
          case "Discounts - Subsidi DP":
            calculationData.discountSubsidiDP = v.priceTotal;
            break;
          case "Discounts":
            calculationData.discount = v.priceTotal;
            break;
          case "Profit":
            calculationData.profit = v.priceTotal;
            break;
        }
      });

    let data = {
      "Tanggal Pengajuan Diskon": momentTZ(approval.createdAt).format(
        "DD/MM/YY HH:mm"
      ),
      "Tanggal Approve/Reject Diskon":
        approval.completionAt || approval.rejectedAt
          ? momentTZ(approval.completionAt || approval.rejectedAt).format(
              "DD/MM/YY HH:mm"
            )
          : "",
      "Tanggal Cancel Diskon": approval.cancelledAt
        ? momentTZ(approval.cancelledAt).format("DD/MM/YY HH:mm")
        : "",
      "Status E-Approval Discount": approval.status,
      Cabang: branch,
      "Nama Salesman": salesNames,
      "No Polisi": approval.licensePlate,
      NOKA: approval.chassisNumber,
      "Nama Unit": approval.carName,
      "Product Type": approval.productType,
      Kilometers: calculationData.km,
      "Stock Days": calculationData.stockDays,
      // "OTR": calculationData.otr,
      "New Price": approval.salesOtr,
      DPP: calculationData.dpp,
      "Unit Purchase": calculationData.unitPurchase,
      "Unit Kinto (PPN)": calculationData.unitKintoPPN,
      "Mobilisasi Unit": calculationData.mobilisasiUnit,
      "Sales Commission": calculationData.salesCommision,
      "Sourcing Fee": calculationData.sourchingFee,
      "Selling Fee": calculationData.sellingFee,
      Lelang: calculationData.lelang,
      "General Repair": calculationData.generalRepair,
      "Body Repair": calculationData.bodyRepair,
      "Biaya Pajak STNK": calculationData.biayaPajakSTNK,
      "BBM Stock Unit": calculationData.bbmStockUnit,
      Others: calculationData.others,
      "Total Cost": calculationData.totalCost,
      "Available Margin": calculationData.availableMargin,
      "Discounts - Subsidi DP": calculationData.discountSubsidiDP,
      Discounts: calculationData.discount,
      Profit: calculationData.profit,
      "Notes E-Approval Diskon": approval.salesNotes,
      "PIC Approval Diskon": approvalPIC,
      "Alasan Penolakan Diskon": approval.rejectedNotes,
      "Tanggal Pembuatan SPK": approval.spkRequestAt
        ? momentTZ(approval.spkRequestAt).format("DD/MM/YY HH:mm")
        : "",
      "Tanggal Approve/Reject SPK":
        approval.spkApprovedAt || approval.spkRejectedAt
          ? momentTZ(approval.spkApprovedAt || approval.spkRejectedAt).format(
              "DD/MM/YY HH:mm"
            )
          : "",
      "Status SPK": statusSPK,
      "PIC SPK": spkPIC,
      "Alasan Penolakan SPK": spkNotes,
      "Booking ID": approval.code,
      "Autotrust Branch": approval.areaCode,
      "Nama Customer": approval.customerName,
      Mobile: approval.customerPhone,
      NIK: approval.customerNIK,
      NPWP: approval.customerNPWP,
      Alamat: approval.customerAddress,
      "Sales Type": approval.salesType,
      "Payment Option": approval.paymentOption,
      Nopol: approval.licensePlate,
      OTR: approval.salesOtr,
      Discount: calculationData.discount,
      "Final Price": approval.salesOtr,
    };

    return data;
  }

  async fetchBranch() {
    const {
      data: { carSaleBranches },
    } = await axios.get(`/car-sales/branches`);
    this.setState({ branches: carSaleBranches });
  }

  getEApprovalStatus() {
    let data = "";
    let { eApprovalStatus } = this.props;
    if (eApprovalStatus === "new") data = "(New)";
    else if (eApprovalStatus === "approval") data = "(Approval)";
    else if (eApprovalStatus === "reject_cancel") data = "(Reject/Cancel)";
    else if (eApprovalStatus === "spk") data = "(SPK)";
    else if (eApprovalStatus === "done") data = "(Done)";
    return data;
  }

  async downloadData() {
    const { type, eApprovalStatus } = this.props;
    const { rangeTime, branch, startDate, endDate } = this.state;
    this.setState({ isLoading: true });

    if (rangeTime.length > 0) {
      const data = await axios
        .post("car-sales/download", {
          startDate,
          endDate,
          branch,
          status: eApprovalStatus,
        })
        .then((result) => {
          if (result.data.carSales.length > 0) {
            const carSales = result.data.carSales.map((v) => {
              const dataCarSales = this.filterDataApproval(v);
              return dataCarSales;
            });

            this.setState({ isLoading: false });
            this.props.visibleModal(false);

            const nameDownload = `Car Sales ${this.getEApprovalStatus()} ${this.onChangeDownload(
              rangeTime[0]
            )} - ${this.onChangeDownload(rangeTime[1])}`;

            downloadExcel(carSales, nameDownload);
            message.success("Berhasil Download Data");
          } else {
            this.setState({ isLoading: false });
            message.error("Data Car Sales Kosong");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          message.error("Gagal Download Data");
        });
    } else {
      this.setState({ isLoading: false });
      message.error("Pilih rentang waktu terlebih dahulu");
    }
  }

  render() {
    const { type, role } = this.props;
    const { branches } = this.state;
    return (
      <Modal
        title={"Download Car Sales"}
        visible={this.props.visible}
        onCancel={() => this.onCancel()}
        onOk={() => this.downloadData()}
        confirmLoading={this.state.isLoading}>
        <p>Pilih Range Waktu Approval</p>
        <DatePicker.RangePicker
          format={"YYYY-MM-DD"}
          onChange={(date, dateString) => this.onChangeRange(date, dateString)}
        />
        <p></p>

        <div>
          <p style={{ marginTop: 5, marginBottom: 5 }}>Pilih Cabang</p>
          <Select
            showSearch
            optionFilterProp="children"
            onChange={(branch) => {
              this.setState({ branch });
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }>
            <Option key={0} value="">
              Semua Cabang
            </Option>
            {branches &&
              branches.map((branch, index) => (
                <Option key={index} value={branch.branch}>
                  {branch.branch}
                </Option>
              ))}
          </Select>
        </div>
      </Modal>
    );
  }
}

export default ModalDownload;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalDownload.js